import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { LocalFinancialTitle } from '@asm/features/quick-order/models/offline-reference-data.model';

@Injectable({ providedIn: 'root' })
export class FinancialTitleRepository extends RepositoryBase<LocalFinancialTitle> {
  protected readonly KEY_PATH = 'financial_titles';
}
